import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=4515bf5e&scoped=true"
import script from "./ConfirmationBox.vue?vue&type=script&lang=js"
export * from "./ConfirmationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515bf5e",
  null
  
)

export default component.exports